export const SUBMENU_X_OFFSET = 3;
export const SUBMENU_Y_OFFSET = -8;
export const SUBMENU_OPEN_TREND_LEFT = "left";
export const SUBMENU_OPEN_TREND_RIGHT = "right";
export const COMPONENT_NAME = "contextmenu-submenu";
